export default __webpack_public_path__ + "static/media/arcana-icon.cbde4440.svg";